// Portal display flags (the fit-check embed settings, the brand chrome, the
// pages waiting for their API on production). The one flags file.
import { IS_PROD } from './api';

/// The Outfino Shopify app is not approved yet, so the Beállítások page must
/// not send merchants to it: no app block for the button, no "App embeds"
/// tracking toggle, no Web Pixel. With this off, the Shopify tabs show the
/// paste-only path (Custom Liquid block, pixel.js in theme.liquid, a Customer
/// events custom pixel). Turn it on once the app is live.
export const SHOW_SHOPIFY_APP_TUTORIAL = false;

/// The sidebar footer's "Shopify admin" button (opens the Outfino app in the
/// Shopify admin). Off while the app is not approved.
export const SHOW_SHOPIFY_ADMIN_LINK = false;

/// The top "A márka jelenleg inaktív." alert (with Kapcsolatfelvétel). Off:
/// the pages still work for an inactive brand (products keep their own
/// "Inaktív" badge).
export const SHOW_BRAND_INACTIVE_ALERT = false;

/// The top Shopify connection alert ("A Shopify-kapcsolat megszakadt — nyisd
/// meg az Outfino appot…"). Off while the app is not approved; the pages
/// still work for a disconnected store.
export const SHOW_SHOPIFY_CONNECTION_ALERT = false;

// Pages whose API is not on production yet: on in every non-production build
// (npm start, build:dev — the API base URL is not api.outfino.io), off in
// build:prod. REACT_APP_ENV overrides when set: 'dev' turns them on, 'prod' /
// 'production' off. Flip to true once the endpoints ship to production.
const ENV = String(process.env.REACT_APP_ENV || '').toLowerCase();
const PRE_RELEASE = ENV === 'dev' ? true : ENV === 'prod' || ENV === 'production' ? false : !IS_PROD;

/// Követők (GET /brands/:id/followers).
export const SHOW_FOLLOWERS_PAGE = PRE_RELEASE;

/// Számlázás (…/billing*), and the Tagok "Számlázás kezelése" toggle with it.
export const SHOW_BILLING_PAGE = PRE_RELEASE;

/// The card gate: the portal lets a brand in only with a validated card
/// (GET /brands/:id/billing → cardStatus 'valid'); until then a full-page
/// card onboarding (components/billing/CardGate.js). Tied to the billing
/// page — on in dev, off in build:prod until the billing API is live there;
/// the CEO decides when it goes on in production.
export const REQUIRE_VALID_CARD = SHOW_BILLING_PAGE;
